import { render, staticRenderFns } from "./FormMerchant.vue?vue&type=template&id=5a889d84"
import script from "./FormMerchant.vue?vue&type=script&lang=js"
export * from "./FormMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports